import { css } from "emotion";
import { Component } from "preact";
import { Link } from "preact-router/match";
import React from "react";
import CMSComponent from "../../components/CMSComponent";
import H3 from "../../components/global/H3";
import H5 from "../../components/global/H5";
import MoreButton from "../../components/global/MoreButton";
import P from "../../components/global/P";
import Image from "../../components/Image";
import CallToAction from "../../components/layout/CallToAction";
import Companies from "../../components/layout/Companies";
import ContentBlock from "../../components/layout/ContentBlock";
import Layout from "../../components/layout/Layout";
import SplitContent from "../../components/layout/SplitContent";
import ColorServices from "../../services/ColorServices";
import { updateTitle } from "../../utils/BrowserUtils";
import { firstOfType, lastOfType, max } from "../../utils/CssUtils";
import Map from "./map/Map";

const descriptionImage = require("../../assets/AboutUs/description.svg");
const ceos = require("../../assets/AboutUs/joshAdam.jpg");
const ambassador = require("../../assets/AboutUs/ambassador.jpg");
const team = require("../../assets/AboutUs/team.jpg");
const ceosTag = require("../../assets/AboutUs/ceos.svg");
const ambassadorTag = require("../../assets/AboutUs/ambassador.svg");
const teamTag = require("../../assets/AboutUs/team.svg");
const humanitixSmile = require("../../assets/humanitixFaces/smile.svg");
const openQuote = require("../../assets/ic_open_quote.svg");

const statementsContainer = css({
  position: "relative",
  marginBottom: 74,
  "@media(max-width: 1140px)": {
    marginBottom: 36
  }
});

const statementsWrapper = css({
  background: "#f9f9fa",
  height: "100%",
  width: "100%",
  clipPath: "polygon(0% 0%, 0% 50%, 100% 50%, 100% 0%)",
  zIndex: 10,
  position: "absolute",
  "@media(max-width: 1140px)": {
    clipPath: "polygon(0% 0%, 0% 25%, 100% 25%, 100% 0%)"
  }
});

const statements = css({
  position: "relative",
  zIndex: 100,
  maxWidth: 1200,
  width: "calc(100% - 160px)",
  margin: "0 auto",
  display: "flex",
  justifyContent: "space-between",
  div: {
    maxWidth: 480,
    width: "100%",
    margin: 0,
    background: "white",
    borderRadius: 4,
    boxShadow: "0px 1px 10px 0px rgba(9,30,66,0.13)",
    padding: 24,
    h3: {
      marginBottom: 16,
      color: ColorServices.getColor("purpleMid")
    }
  },
  "@media(max-width: 1140px)": {
    width: "100%",
    flexDirection: "column",
    maxWidth: 480,
    padding: "0 14px",
    div: {
      [firstOfType()]: {
        marginBottom: 24
      }
    }
  }
});

const happyClientsStyles = css({
  "#clientsTitleDiv": {
    textAlign: "center",
    img: {
      width: 85,
      height: 60,
      marginBottom: 16
    }
  },
  "#testimonialWrapper": {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    paddingTop: 48
  },
  ".testimonial": {
    [firstOfType()]: {
      marginRight: 32
    },
    maxWidth: 484,
    paddingLeft: 64,
    backgroundImage: `url(${openQuote})`,
    backgroundRepeat: "no-repeat",
    h5: {
      marginBottom: 16,
      [firstOfType()]: {
        marginBottom: 4
      }
    }
  },
  [max(1159)]: {
    ".testimonial": {
      paddingLeft: 0,
      paddingTop: 40,
      [firstOfType()]: {
        marginRight: 0,
        marginBottom: 24
      }
    }
  }
});

const meetOutTeamStyles = css({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  alignItems: "center",
  "#meetOurTeamImages": {
    position: "relative",
    minHeight: 335,
    maxWidth: 624,
    width: "100%",
    "#adamJosh": {
      position: "absolute",
      maxWidth: 250,
      top: 0,
      left: 0,
      img: {
        [lastOfType()]: {
          position: "absolute",
          bottom: 5,
          left: 0
        }
      }
    },
    "#team": {
      position: "absolute",
      maxWidth: 350,
      top: 68,
      left: 274,
      img: {
        [lastOfType()]: {
          position: "absolute",
          bottom: 5,
          left: 0
        }
      }
    },
    "#ambassador": {
      position: "absolute",
      maxWidth: 175,
      top: 180,
      left: 75,
      img: {
        [lastOfType()]: {
          position: "absolute",
          bottom: 5,
          left: 0
        }
      }
    }
  },
  [max(970)]: {
    display: "block",
    alignItems: "center",
    "#meetOurTeamText": {
      textAlign: "left",
      maxWidth: 298,
      margin: "0 auto",
      marginBottom: 24,
      h3: {
        marginBottom: 16
      }
    },
    "#meetOurTeamImages": {
      position: "relative",
      minHeight: 335,
      maxWidth: 298,
      margin: "0 auto",
      width: "100%",
      "#adamJosh": {
        position: "absolute",
        maxWidth: 200,
        top: 160,
        left: 0,
        img: {
          [lastOfType()]: {
            display: "none"
          }
        }
      },
      "#team": {
        position: "absolute",
        maxWidth: 250,
        top: 0,
        left: 42,
        img: {
          [lastOfType()]: {
            display: "none"
          }
        }
      },
      "#ambassador": {
        position: "absolute",
        maxWidth: 78,
        top: 160,
        left: 214,
        img: {
          [lastOfType()]: {
            display: "none"
          }
        }
      }
    }
  }
});

class AboutUs extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    updateTitle("About us");
  }

  render() {
    const { localeData, locale } = this.props;
    const { infoEmail, country } = localeData;
    return (
      <Layout>
        <div style={{ position: "relative" }}>
          <Map />
          <SplitContent
            image={descriptionImage}
            bgColor="grey"
            alt="Ticket flying over a mountain"
          >
            <H3>About us</H3>
            <P>
              We are passionate about disrupting the events ticketing industry
              and redirecting 100% of profits from bookings fees to projects
              that address the education gaps affecting the most disadvantaged
              children here in {country} and overseas. We believe education is a
              ticket to opportunity and that every child has the right to reach
              their potential.{" "}
            </P>
            <P>
              Our projects aim to create a world where all children are born
              into a community where they can flourish and have the tools to
              create their own impact. We invite you to partner with us as we
              transform ticketing into a force for good.{" "}
            </P>
          </SplitContent>
          <div className={statementsContainer}>
            <div className={statementsWrapper} />
            <div className={statements}>
              <div>
                <H3>Our Mission</H3>
                <P>
                  Provide opportunity through education to every child who is
                  left behind through poverty, disadvantage or disability.
                </P>
              </div>
              <div>
                <H3>Our Vision</H3>
                <P>
                  We envision a better, fairer world, where every child has
                  access to education, opportunity and a fair-go in life.
                </P>
              </div>
            </div>
          </div>
          <Companies />
          <ContentBlock>
            <div className={happyClientsStyles}>
              <div id="clientsTitleDiv">
                <Image
                  imageURL={humanitixSmile}
                  alt="Stylized Humanitix logo in the shape of a smiley face"
                />
                <H3>Happy Clients</H3>
              </div>
              <div id="testimonialWrapper">
                <div class="testimonial">
                  <H5>Lyssa Borham, UN Women</H5>
                  <H5>UN Women International Women’s Day Breakfast</H5>
                  <P>
                    “Co-ordinating the largest International Women's day event
                    series in the country is a mammoth task. With over 5500
                    people across 5 cities it means we need a really effective
                    ticketing platform. We found that Humanitix offer the best
                    product for our unique event needs, at the best price.
                    Seating maps and data collection tools made following up
                    customer information a breeze.”
                  </P>
                </div>
                <div class="testimonial">
                  <H5>Dan Mylonas, Brand Director</H5>
                  <H5>The Grounds of Alexandria</H5>
                  <P>
                    “We have so many events running meaning we can’t compromise
                    on the quality and usability of our ticketing solution.
                    Humanitix has been nothing but a dream to use. Their
                    customer support has been incredible and works so well for
                    us as an organisation - all whilst giving us the opportunity
                    to give back.”
                  </P>
                </div>
              </div>
            </div>
          </ContentBlock>
          <ContentBlock color="grey">
            <div className={meetOutTeamStyles}>
              <div id="meetOurTeamText">
                <H3>Meet our team</H3>
                <MoreButton label="See our story" path="/our-stories" locale />
              </div>
              <div id="meetOurTeamImages">
                <div id="adamJosh">
                  <Link href={`/${locale}/our-stories?l=cofounders`}>
                    <Image imageURL={ceos} alt={"Picture of the Co-founders"} />
                    <Image imageURL={ceosTag} alt="Co-founders label" />
                  </Link>
                </div>
                <div id="team">
                  <Link href={`/${locale}/our-stories?l=team`}>
                    <Image
                      imageURL={team}
                      alt={"Picture of the Humanitix Team"}
                    />
                    <Image imageURL={teamTag} alt="Humani Team label" />
                  </Link>
                </div>
                <div id="ambassador">
                  <Link href={`/${locale}/our-stories?l=ambassador`}>
                    <Image
                      imageURL={ambassador}
                      alt={"Picture of the Ambassador John Eales"}
                    />
                    <Image imageURL={ambassadorTag} alt="Ambassadors label" />
                  </Link>
                </div>
              </div>
            </div>
          </ContentBlock>
          <CallToAction
            text="Want to unlock the philanthropic potential of your event?"
            buttonText="Get in touch"
            link="/contact-us"
            localeData={localeData}
            locale={locale}
          />
        </div>
      </Layout>
    );
  }
}

export default CMSComponent(null, AboutUs, 1500);
